import Vue from 'vue';
import _ from "lodash";

let config = {
    id: "id",
    children: "children",
    pid: "paperid"
}

function getData(tree, id) {
    let stack = [];
    let result = {};
    if (Array.isArray(tree) && tree.length > 0) {
        // tree.
        for (let i = 0;i < tree.length;i++) {
            stack.push(tree[i]);
        }
    } else if (typeof tree === "object") {
        stack = [tree];
    }
    while (stack.length) {
        let node = stack.shift();
        if (node[config.id] === id) {
            result = node;
            return result;
        }
        if (node[config.children] && node[config.children].length > 0) {
            stack = stack.concat(node[config.children]);
        }
    }
    return result;
}

function lookForAllData(data = [], arr = []) {
    for (let item of data) {
        arr.push(item)
        if (item.children && item.children.length) lookForAllData(item.children, arr)
    }
    return arr
}

function lookForAllId(data = [], arr = []) {
    for (let item of data) {
        arr.push(item.id)
        if (item.children && item.children.length) lookForAllId(item.children, arr)
    }
    return arr
}

function updateIndicator(data) {
    // let fromDataJSON = localStorage.getItem('questionData');
    // if (fromDataJSON){
    //     let fromData_ = JSON.parse(fromDataJSON);
    //     fromData_.indicatorTrees = data
    //     localStorage.setItem('questionData', JSON.stringify(fromData_));
    // }
}

export default {
    namespaced: true,
    state: {
        indicatorTrees: [],
        id: 1,
        selectedNode: null
    },
    getters: {
        indicatorList( state ) {
            return lookForAllData(state.indicatorTrees)
        },
        indicatorTreesList(state) {
            return _.cloneDeep(state.indicatorTrees)
        },
        topScore(state) {
            let score = 0
            for (let i = 0; i < state.indicatorTrees.length; i++) {
                score += Number(state.indicatorTrees[i].targetNum)
            }
            return score
        }
    },
    mutations: {
        init(state, { data, id }) {
            if (data){
                data.forEach(item => {
                    item.selected = false
                })
            }
            state.indicatorTrees = data
            state.id = id
        },
        add(state, {node, pId}) {
            if (node) {
                node.id = state.id
                if (pId) {
                    let currentNode = getData(state.indicatorTrees, pId);
                    if (Object.keys(currentNode).length > 0) {
                        if (!currentNode.children) {
                            Vue.set(currentNode, 'children', [])
                        }
                        currentNode.children.push(node);
                    }
                } else if (pId === "" || pId === 0 || pId === "0") { // 说明操作的根节点
                    state.indicatorTrees.push(node);
                }
                state.id++
                updateIndicator(state.indicatorTrees)
            }
        },
        update(state, data) {
            const currentNode = getData(state.indicatorTrees, data.id)
            if (currentNode) {
                for (const key in data) {
                    if (key !== 'id') {
                        currentNode[key] = data[key]
                    }
                }
                updateIndicator(state.indicatorTrees)
            }
        },
        remove(state, id) {
            let currentNode = getData(state.indicatorTrees, id);
            if (Object.keys(currentNode).length > 0) {
                console.log(currentNode[config.pid])
                let parentNode = currentNode[config.pid] ? getData(state.indicatorTrees, currentNode[config.pid]) : state.indicatorTrees;
                let parent = parentNode[config.children] ? parentNode[config.children] : parentNode;
                let currentIndex = parent.findIndex(v => v[config.id] === id);
                currentIndex > -1 && parent.splice(currentIndex, 1);
                updateIndicator(state.indicatorTrees)
            }
        },
        setSelectedNode(state, node) {
            state.selectedNode = node
        }
    },
    actions: {
        init({ state, rootState, commit,  dispatch,   getters, rootGetters }, indicatorTrees) {
            // 初始化
            if (indicatorTrees && indicatorTrees.length) {
                let id = 1
                const ids = lookForAllId(indicatorTrees)
                let maxId = Math.max.apply(null, ids)
                if (maxId && maxId !== -Infinity) {
                    id = ++maxId
                }
                commit('init', {
                    data: indicatorTrees,
                    id: id
                })
            }
        },
        add({ state, rootState, commit,  dispatch,   getters, rootGetters }) {

        },
        remove({ state, rootState, commit,  dispatch,   getters, rootGetters }, id) {
            // 获取id关联所有treeId
            // const currentNode = getData(state.indicatorTrees, id);
            // console.log(currentNode)
            // const ids = lookForAllData([currentNode])
            // console.log(ids)
            // 根据id删除tree

            // 删除关联题目
        },
        changeNode({ state, rootState, commit,  dispatch,   getters, rootGetters }, {isSelected = false, node}) {
            if (isSelected) {
                commit('setSelectedNode', node)
            }else {
                commit('setSelectedNode', null)
            }
        }
    }
}
